import { Trans } from '@lingui/react/macro';
import { ActivityEntry, ActivityEntryText } from 'app/domains/common-ui/ActivityLog';
import { getIcon } from './utils';
export function SignRequestFailed(props) {
    const { timestamp } = props;
    return (<ActivityEntry appearance="danger" icon={getIcon('danger')} timestamp={timestamp} text={<ActivityEntryText>
          <Trans comment="Esigning activity - The document failed to be sent for eSigning">
            The document failed to be sent for eSigning
          </Trans>
        </ActivityEntryText>}/>);
}
